import * as React from 'react';
import { Router, Route, Redirect } from 'react-router';
import { Provider } from 'react-redux';
import store, { history } from '../store';
import App from '../containers/App';
import SetRouteParams from '../containers/SetRouteParams';
import StaticPage from '../containers/StaticPage';
import NotFoundPage from '../components/NotFoundPage';
import DriveItemListPage from '../containers/DriveItemListPage';
import DriveItemDetailPage from '../containers/DriveItemDetailPage';
import ParametersPage from '../components/ParametersPage';
import ProfilePage from '../containers/ProfilePage';
import TheaterPage from '../containers/TheaterPage';
import Editor from '../containers/Editor';
import ProposalStatsPage from '../containers/ProposalStatsPage';
import RoutesUtils from '../utils/routes';

import { RoutePath } from './constants';
import Authentication from '../containers/Authentication';

const routes = () => (
	<Provider store={store}>
		<Router history={history}>
			<Redirect from={RoutePath.Default} to={RoutesUtils.getPathHome()} />
			<Route path={RoutePath.Default} component={SetRouteParams(App)}>

				<Route path={RoutePath.Home} component={StaticPage} />
				<Route path={RoutePath.StaticPage} component={StaticPage} />
				<Route path={RoutePath.ParametersPage} component={ParametersPage} />
				<Route path={RoutePath.ProfilePage} component={ProfilePage} />
				<Route path={RoutePath.ProposalStatsPage} component={ProposalStatsPage} />
				<Route path={RoutePath.DriveItemListPage} component={DriveItemListPage} />
				<Route path={RoutePath.TheaterList} component={DriveItemListPage} />
				<Route path={RoutePath.Theater} component={TheaterPage} />
				<Route path={RoutePath.Authentication} component={Authentication} />
				<Route path={RoutePath.DriveItemDetailPage} component={DriveItemDetailPage} />
				<Route path={RoutePath.Editor} component={Editor} />

				<Route path="*" component={NotFoundPage} />
			</Route>
		</Router>
	</Provider>
);

export default routes;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routes/index.tsx